import { ProductRatingRptServices } from '../services/ProductRatingRptServices';
import { ProductRatingRptConstants } from '../constants';
import { alertActions } from '.';

export const ProductRatingRptActions = {
    getAll,
    loadingData,
    exportData
};

function getAll(obj) {
    return dispatch => {
        dispatch(request());
        ProductRatingRptServices.fetchVerificationData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows; delete v.ProductId });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: ProductRatingRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: ProductRatingRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: ProductRatingRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: ProductRatingRptConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        ProductRatingRptServices.fetchVerificationData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows; delete v.ProductId });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: ProductRatingRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: ProductRatingRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: ProductRatingRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: ProductRatingRptConstants.LOADING_REQUEST, isbool
    }
}
